import {Component, Inject, inject, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {ModalData} from "../../../shared-module/types/modal-data.type";
import ModalService, {ModalRef} from "../../../shared-module/services/modal.service";
import {DatePipe} from "@angular/common";
import Product, {TelevisionProduct} from "../../../shared-module/model/product.model";
import {ButtonComponent} from "../../../shared-module/components/button/button.component";
import {ProductSubType} from "../../../shared-module/types/product-sub.type";
import {ProductState} from "../../../shared-module/enums/product-state";
import {AuthService} from "../../../shared-module/services/auth.service";
import {SuccessModalComponent} from "../../../shared-module/components/success-modal/success-modal.component";
import ProductStore from "../../../shared-module/services/Stores/product.store";
import Subscription from "../../../shared-module/model/subscription.model";
import {ModalEventTypes} from "../../../shared-module/enums/modal.event";

@Component({
    selector: 'app-product-order-modal',
    imports: [
        ButtonComponent,
        DatePipe,
    ],
    templateUrl: './product-terminate-modal.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './product-terminate-modal.component.scss'
})
export class ProductTerminateModalComponent implements OnInit {
  private readonly authService: AuthService = inject(AuthService);
  private readonly modalService: ModalService = inject(ModalService);
  readonly modalRef: ModalRef<ProductTerminateModalComponent> = inject<ModalRef<ProductTerminateModalComponent>>(ModalRef);
  private readonly productStore: ProductStore = inject(ProductStore);
  protected readonly ProductSubType: typeof ProductSubType = ProductSubType;
  protected readonly ProductState: typeof ProductState = ProductState;
  protected readonly ModalEventTypes: typeof ModalEventTypes = ModalEventTypes;
  protected readonly now: Date = new Date();

  // eslint-disable-next-line @angular-eslint/prefer-inject
  constructor(@Inject(ModalData) public product: TelevisionProduct) {}

  public ngOnInit(): void {
    this.authService.getSelectedSubscription().subscribe((subscription: Subscription | null) => {
      if (!subscription) {
        return;
      }
      this.productStore.reset();
      this.productStore.forParent('subscriptions', subscription);
    });
  }

  public terminate(): void {
    this.productStore.delete(this.product).subscribe((updatedProduct: Product) => {
      this.modalRef.close(updatedProduct, ModalEventTypes.Confirmed);

      this.modalService.open(SuccessModalComponent, null, {
        title: 'Product opgezegd!',
        subtitle: 'We hebben je verzoek in goede orde ontvangen en zeggen ' + updatedProduct.specs.title + ' op. Je kunt ' + updatedProduct.specs.title + ' nog gebruiken tot ' + (new DatePipe('en-US').transform(updatedProduct.date_expiry, 'dd-MM-yyyy')) + '.',
        width: '500px',
        showCloseButton: true,
      });
      return updatedProduct;
    });
  }
}
